/**
 * DoctorAuth API istek gövdeleri için yardımcılar.
 */

export function normalizeDoctorUserType(userType) {
  const value = String(userType || "Doctor").trim();
  if (value.toLowerCase() === "doctor") return "Doctor";
  if (value.toLowerCase() === "assistant") return "Assistant";
  return value;
}

export function withDoctorRegisterDefaults(payload) {
  return {
    language: "tr",
    userType: normalizeDoctorUserType(payload?.userType),
    ...payload,
  };
}

export function buildCheckAccountPayload({ email, phone } = {}) {
  const body = {};
  if (email) body.email = email;
  if (phone) body.phone = phone;
  return body;
}
